import { formatCurrency } from "@/modules/expenses/components/CurrencyAmount";

type Props = {
  totalAmount: number;
  usedAmount: number;
  currency?: string;
  size?: "sm" | "md" | "lg";
  showLabels?: boolean;
  className?: string;
};

function utilizationColor(pct: number): string {
  if (pct >= 90) return "hsl(0,70%,50%)";
  if (pct >= 75) return "hsl(38,92%,50%)";
  return "hsl(142,65%,42%)";
}

export function BudgetUtilizationBar({
  totalAmount,
  usedAmount,
  currency = "AED",
  size = "md",
  showLabels = true,
  className,
}: Props) {
  const pct = totalAmount > 0 ? Math.min(100, (usedAmount / totalAmount) * 100) : 0;
  const remaining = totalAmount - usedAmount;
  const color = utilizationColor(pct);

  const barHeight =
    size === "lg" ? "h-3" : size === "sm" ? "h-1.5" : "h-2";

  return (
    <div className={className}>
      {showLabels && (
        <div className="mb-1 flex items-center justify-between text-[12px]">
          <span className="text-muted-foreground">
            {formatCurrency(usedAmount, currency)} used of{" "}
            {formatCurrency(totalAmount, currency)}
          </span>
          <span
            className={`font-medium ${
              remaining < 0 ? "text-[hsl(0,70%,45%)]" : "text-foreground"
            }`}
          >
            {formatCurrency(Math.abs(remaining), currency)}{" "}
            {remaining < 0 ? "over" : "remaining"}
          </span>
        </div>
      )}
      <div
        className={`w-full overflow-hidden rounded-full ${barHeight}`}
        style={{ background: "hsl(210,16%,93%)" }}
      >
        <div
          className={`${barHeight} rounded-full transition-all`}
          style={{ width: `${pct}%`, background: color }}
        />
      </div>
      {showLabels && (
        <div className="mt-1 text-[11px] text-muted-foreground">
          {Math.round(pct * 10) / 10}% utilized
        </div>
      )}
    </div>
  );
}
